import { useTranslation } from 'react-i18next';

import Reason1 from '@/images/whyPDF/reason1.svg';
import Reason2 from '@/images/whyPDF/reason2.svg';
import Reason3 from '@/images/whyPDF/reason3.svg';
import Reason4 from '@/images/whyPDF/reason4.svg';

function WhyPDFe() {
	const { t } = useTranslation();

	const reasons = t('home.whyPDFe.reasons', { returnObjects: true });
	const reasonImages = [Reason1, Reason2, Reason3, Reason4];

	return (
		<div className="flex w-full flex-col gap-[77px] md:lacks-hover:gap-12">
			<div className="flex flex-col items-start gap-3 md:lacks-hover:items-center md:lacks-hover:gap-4 lg:gap-4">
				<h3 className="font-title text-[32px] font-semibold leading-10 md:lacks-hover:text-[40px] md:lacks-hover:leading-[52px] lg:text-[40px] lg:font-bold lg:leading-[52px]">
					{t('home.whyPDFe.title')}
				</h3>
				<h4 className="text-sm font-normal leading-6 md:lacks-hover:text-base lg:text-base lg:leading-7">
					{t('home.whyPDFe.subtitle')}
				</h4>
			</div>
			<div>
				{reasons.map(({ title, subtitle, description }, index) => {
					return (
						<div
							className="flex flex-col-reverse items-start justify-between border-t border-black py-5 md:lacks-hover:flex-row md:lacks-hover:gap-[113px] lg:flex-row"
							key={index}
						>
							<div className="mt-5 flex flex-col gap-[13px] lg:mt-0 lg:can-hover:flex-row lg:can-hover:gap-[124px]">
								<span className="w-full font-semibold leading-7 text-red md:lacks-hover:w-[350px] lg:can-hover:w-[189px]">
									{title}
								</span>
								<div className="flex w-full flex-col gap-[13px] md:lacks-hover:w-[350px] md:lacks-hover:gap-5 lg:gap-5 lg:can-hover:w-[293px]">
									<span className="text-sm font-semibold leading-6">
										{subtitle}
									</span>
									<p className="text-xs font-normal leading-5 text-grey-500 md:lacks-hover:w-[350px]">
										{description}
									</p>
								</div>
							</div>
							<div className="group flex h-[257px] w-[280px] transform items-center justify-center self-center rounded bg-grey-100 transition duration-500 hover:bg-red focus:bg-red md:lacks-hover:h-[316px] md:lacks-hover:w-[257px] lg:can-hover:h-[268px] lg:can-hover:w-[292px]">
								<div className="h-[132px] w-[144px] transform rounded bg-black transition duration-500 group-hover:scale-125 md:lacks-hover:h-[138px] md:lacks-hover:w-[150px] lg:can-hover:h-[138px] lg:can-hover:w-[150px]">
									<img
										alt={`reason-${title}`}
										src={reasonImages[index]}
										width="150"
										height="138"
										loading="lazy"
									/>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default WhyPDFe;
